import graphQLClient from 'config/graphql-instance';
import { gql } from 'graphql-request';
import type { ChargeSettingParty } from './queries';

export type GQLDeleteChargeSetting = {
  deleteChargeSetting: {
    _id: string
  }
}

type DeleteChargeSettingPayload = {
  settingId: string
}

export const deleteChargeSetting = async (payload: DeleteChargeSettingPayload) => {
  const mutation = gql`
    mutation DeleteChargeSetting($settingId: ID!) {
      deleteChargeSetting(_id: $settingId) {
        _id
      }
    }
  `;

  const response = await graphQLClient()
    .request<GQLDeleteChargeSetting, DeleteChargeSettingPayload>(mutation, payload);
  return response;
};

export type GQLUpdateChargeSetting = {
  updateChargeSetting: {
    _id: string
  }
}

export type ChargeSettingPartyInput = {
  role: string;
  percent: number;
}

export type ChargeSettingData = {
  amount_override: number | null,
  buyer_at: number | null,
  buyer_before: number | null,
  seller_at: number | null,
  seller_before: number | null
  by_others: number | null,
  code: string | null,
  letter: string | null,
  number: string | null,
  payees?: ChargeSettingParty[] | null,
  payers?: ChargeSettingParty[] | null
}

export type GQLUpdateChargeSettingPayload = {
  settingId: string,
  data: ChargeSettingData
}

export const updateChargeSetting = async (payload: GQLUpdateChargeSettingPayload) => {
  const mutation = gql`
    mutation UpdateChargeSetting($settingId: ID!, $data: ChargeSettingInput!) {
      updateChargeSetting(_id: $settingId, data: $data) {
        _id
      }
    }
  `;

  const response = await graphQLClient()
    .request<GQLUpdateChargeSetting, GQLUpdateChargeSettingPayload>(mutation, payload);
  return response;
};

export type GQLCreateChargeSetting = {
  createChargeSetting: {
    _id: string
  }
}

export type GQLCreateChargeSettingPayload = ChargeSettingData

export const createChargeSetting = async (payload: GQLCreateChargeSettingPayload) => {
  const mutation = gql`
    mutation CreateChargeSetting(
      $buyer_at: Float!,
      $buyer_before: Float!,
      $by_others: Float!,
      $seller_at: Float!,
      $seller_before: Float!,
      $amount_override: Float,
      $code: String,
      $letter: String,
      $number: String,
      $payees: [ChargeSettingPartyInput!],
      $payers: [ChargeSettingPartyInput!]) {
      createChargeSetting(buyer_at: $buyer_at,
      buyer_before: $buyer_before,
      by_others: $by_others,
      seller_at: $seller_at, seller_before: $seller_before, amount_override: $amount_override, code: $code, letter: $letter, number: $number, payees: $payees, payers: $payers) {
        _id
      }
    }
  `;

  const response = await graphQLClient()
    .request<GQLCreateChargeSetting, GQLCreateChargeSettingPayload>(mutation, payload);
  return response;
};
